import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { Button, DatePicker, Form, Input, message } from "antd";
import { fmtDateTimeFull } from "@extensions/utils";
import { strDate2Server } from "@extensions/convert";
import dayjs from "dayjs";

const CompanyItemMain = ({ companyId, onClose }) => {
  const [item, setItem] = useState();
  const [loading, setLoading] = useState();
  const [form] = Form.useForm();

  const getData = () => {
    if (!companyId) return;
    
    setLoading(true);
    serverFetch(`company/${companyId}`)
      .then(data => {
        const newData = {...data, supportFinishDate: data.supportFinishDate ? dayjs(data.supportFinishDate) : null};
        setItem(newData);
        form.setFieldsValue(newData);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(() => {
    if (companyId) {
      getData();
    }
  }, [companyId]);

  const onValuesChange = value => setItem({...item, ...value});

  const onSave = () => {
    setLoading(true);
    const payload = { ...item };
    if (payload.supportFinishDate != null && payload.supportFinishDate !== "") {
      payload.supportFinishDate = strDate2Server(payload.supportFinishDate);
    }
    serverFetch(`company`, { method: "PUT", bodyData: payload })
      .then(() => {
        setLoading(false);
        message.success("Компания обновлена");
        onClose(true); // Закрываем форму после успешного сохранения
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  return (
    <Form 
      form={form} 
      onValuesChange={onValuesChange} 
      labelCol={{ span: 6 }} 
      wrapperCol={{ span: 24 }} 
      colon={false} 
      disabled={loading} 
      style={{maxWidth: 500}}
    >
      <Form.Item label="#"><Input value={item?.id} disabled/></Form.Item>
      <Form.Item label="Наименование" name="name"><Input /></Form.Item>
      <Form.Item label="ИНН" name="inn"><Input /></Form.Item>
      <Form.Item label="Регистрация"><Input value={fmtDateTimeFull(item?.regDateTime)} disabled/></Form.Item>
      <Form.Item label="Адрес" name="adres"><Input /></Form.Item>
      <Form.Item label="Телефоны" name="phone"><Input /></Form.Item>
      <Form.Item label="Сотрудник" name="sotrName"><Input /></Form.Item>
      <Form.Item label="Почта" name="email"><Input /></Form.Item>
      <Form.Item label="Подписка" name="supportFinishDate"><DatePicker format="DD.MM.YYYY" /></Form.Item>
      <Form.Item label=" ">
        <Button className="misoft-btn" onClick={onSave} loading={loading}>
          Сохранить
        </Button>
        <Button style={{ marginLeft: 8 }} onClick={() => onClose(false)}>
          Закрыть
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CompanyItemMain;
